import Typography from "../shared/typography";
import Card from "../shared/card";
import { cn } from "../utls/utils";
import RecordMetaGrid, {
  RecordMetaItem,
} from "./record-meta-grid";

export type MedicalRecordSummaryMeta = RecordMetaItem;

export interface MedicalRecordSummaryCardProps {
  title: string;
  subtitle?: string | null;
  status?: string | null;
  statusTone?: "default" | "success" | "warning" | "info";
  meta?: MedicalRecordSummaryMeta[];
  onClick?: () => void;
}

const statusToneStyles: Record<
  NonNullable<MedicalRecordSummaryCardProps["statusTone"]>,
  string
> = {
  default: "bg-beige-200 text-brown-800",
  success: "bg-green-100 text-green-700",
  warning: "bg-yellow-100 text-yellow-800",
  info: "bg-blue-100 text-blue-700",
};

export function MedicalRecordSummaryCard({
  title,
  subtitle,
  status,
  statusTone = "default",
  meta,
  onClick,
}: MedicalRecordSummaryCardProps) {
  const filteredMeta = meta?.filter((item) => Boolean(item.value));

  return (
    <Card
      variant="cream"
      elevation={1}
      className="w-full"
      onClick={onClick}
      hoverEffect={!!onClick}
    >
      <Card.Body className="space-y-3">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <Typography variant="subtitle1" className="text-brown-900">
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" className="text-brown-600">
                {subtitle}
              </Typography>
            )}
          </div>
          {status && (
            <span
              className={cn(
                "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide",
                statusToneStyles[statusTone]
              )}
            >
              {status}
            </span>
          )}
        </div>

        {filteredMeta && filteredMeta.length > 0 ? (
          <RecordMetaGrid items={filteredMeta} className="pt-2" />
        ) : null}
      </Card.Body>
    </Card>
  );
}

export default MedicalRecordSummaryCard;
